/**
 * 回頂按鈕(REQ-20260421008 §4)。
 * 捲動超過 400px 時浮現於右下角,點擊平滑回到頁首。
 */
import { useEffect, useState } from 'react';

// 只要捲超過一個合理距離(半個視窗高或 200px)就顯示;短頁面不會觸發
const MIN_SCROLL_PX = 200;

export function BackToTopButton(): JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = (): void => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const threshold = Math.min(MIN_SCROLL_PX, window.innerHeight / 2);
        setVisible(window.scrollY > threshold);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="no-print fixed bottom-6 right-6 z-20 bg-blue-600 text-white rounded-full w-12 h-12 shadow-lg hover:bg-blue-700 flex items-center justify-center text-lg"
      aria-label="回到最上層"
      data-testid="back-to-top"
    >
      ↑
    </button>
  );
}
